import { getBrandedActionColors, getVisiblePrimaryTextColor } from '@/util/theme-color';
import type { AuthColorScheme } from './useAuthColorScheme';

// The page and the credential card each scheme paints behind a firm's color.
// Keep these in step with `--auth-page` and `--auth-card` in index.scss: a
// firm color is only adjusted for contrast against what it actually sits on.
const ADVISOR_AUTH_SURFACES: Record<AuthColorScheme, { page: string; card: string }> = {
  dark: { page: '#0b1015', card: '#0c1016' },
  light: { page: '#ffffff', card: '#ffffff' },
};

const ADVISOR_AUTH_HERO_SURFACES: Record<AuthColorScheme, { page: string; card: string }> = {
  dark: { page: '#0b1015', card: '#070a0f' },
  light: { page: '#ffffff', card: '#eef4fa' },
};

export const getAdvisorAuthBrandActionColors = (
  brandColor: string,
  scheme: AuthColorScheme = 'dark',
) =>
  getBrandedActionColors({
    primaryColor: brandColor,
    surfaceColor: ADVISOR_AUTH_SURFACES[scheme].card,
    pageBackgroundColor: ADVISOR_AUTH_SURFACES[scheme].page,
  });

export const getAdvisorAuthBrandTextColor = (
  brandColor: string,
  scheme: AuthColorScheme = 'dark',
) =>
  getVisiblePrimaryTextColor({
    primaryColor: brandColor,
    surfaceColor: ADVISOR_AUTH_SURFACES[scheme].card,
    pageBackgroundColor: ADVISOR_AUTH_SURFACES[scheme].page,
  });

export const getAdvisorAuthBrandHeroAccentColor = (
  brandColor: string,
  scheme: AuthColorScheme = 'dark',
) =>
  getVisiblePrimaryTextColor({
    primaryColor: brandColor,
    surfaceColor: ADVISOR_AUTH_HERO_SURFACES[scheme].card,
    pageBackgroundColor: ADVISOR_AUTH_HERO_SURFACES[scheme].page,
  });
